import "../../styles/about/aboutFeatures.css";

const FEATURES = [
  {
    icon: "🎬",
    title: "Interactive Visualizations",
    description:
      "Create step-by-step visual explanations instead of long blocks of text.",
  },
  {
    icon: "🧠",
    title: "Animation-Driven Learning",
    description:
      "Animations help you understand how and why things work, not just memorize.",
  },
  {
    icon: "🛠️",
    title: "Studio for Creators",
    description:
      "Create, edit, and publish your own visual explanations with ease.",
  },
];

const AboutFeatures = () => {
  return (
    <section className="about-features">
      <div className="about-features-header">
        <h2>What VisualLab Offers</h2>
        <p>Everything is built to make learning intuitive and visual.</p>
      </div>

      <div className="about-features-container">
        {FEATURES.map((feature, index) => (
          <div key={index} className="about-feature-card">
            <div className="icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutFeatures;
